import { useEffect, useMemo } from 'react';

import Colon from '@lcsc-ui/components/Colon';
import { buriedPoint } from '@lcsc-ui/utils/buriedPoint';
import { Popover } from 'antd';

export default function ProductActivity({ data }) {
  const productRecord = data?.productRecord || {};

  const handleNavToDetail = () => {
    const url = 'https://smt.szlcsc.com/';
    buriedPoint({
      ty: 'click',
      cp: 'product_detail',
      op: 'PCB-MF',
      data: {
        hf: url,
      },
    });
    window.open(url, '_blank');
  };

  useEffect(() => {
    if (productRecord?.smtLabel) {
      buriedPoint({
        ty: 'view',
        cp: 'product_detail',
        op: 'PCB-MF',
      });
    }
  }, [productRecord?.smtLabel]);

  // SMT扩展库
  const smtDom = useMemo(() => {
    return (
      productRecord?.smtLabel && (
        <span className="mr-[10px] inline-block h-[20px] text-nowrap rounded-[3px] border-[1px] border-solid border-[#D2E2EB] bg-[#fff] leading-[18px] text-[#1FA0E8]">
          <span className="inline-block rounded-[3px_0_6px_3px] bg-[#F1F7FC] px-[5px]">SMT</span>
          <span className="inline-block px-[5px]">{productRecord?.smtLabel?.replace('SMT', '')}</span>
        </span>
      )
    );
  }, [productRecord?.smtLabel]);

  const jlcDom = useMemo(() => {
    return (
      data?.isShowSmtSubsidyInfo && (
        <span
          className="mr-[10px] inline-block h-[20px] text-nowrap rounded-[3px] border-[1px] border-solid border-[#D2E2EB] bg-[#fff] leading-[18px] text-[#1FA0E8]"
          title="整盘备私有库存元器件到“嘉立创SMT”，价格比立创商城低5%~10%左右，差价部分由嘉立创SMT补贴"
        >
          <span className="inline-block rounded-[3px_0_6px_3px] bg-[#F1F7FC] px-[5px]">SMT补贴</span>
          <span className="inline-block px-[5px]">嘉立创</span>
        </span>
      )
    );
  }, [data?.isShowSmtSubsidyInfo]);

  const pcbDom = useMemo(() => {
    return (
      productRecord?.smtLabel && (
        <Popover
          content={
            <div>
              <h2 className="text-[16px] text-[#0B1832] font-bold">PCB免费打样，SMT包工包料</h2>
              <div className="mt-[10px] flex items-end">
                <div>
                  6-32层免费升级盘中孔工艺
                  <br />
                  双面板低至210元/m² 四层板低至400元/m²
                </div>
                <button className="ml-[10px] text-[#199FE9]" onClick={handleNavToDetail}>
                  {'了解详情 >'}
                </button>
              </div>
            </div>
          }
          placement="right"
          trigger="hover"
        >
          <span
            className="mr-[10px] inline-block h-[20px] text-nowrap rounded-[3px] border-[1px] border-solid border-[#D2E2EB] bg-[#fff] leading-[18px] text-[#1FA0E8] cursor-pointer"
            onClick={handleNavToDetail}
          >
            <span className="inline-block rounded-[3px_0_6px_3px] bg-[#F1F7FC] px-[5px]">PCB</span>
            <span className="inline-block px-[5px]">免费打样</span>
          </span>
        </Popover>
      )
    );
  }, [productRecord?.smtLabel]);

  const otherDom = useMemo(() => {
    const { selfProductCode, lcBookProductVO } = productRecord;

    // 自营p转c从lcBookProductVO取，海外代购从data取
    const tariffDataSource = selfProductCode ? lcBookProductVO : data;

    const { isTariff, tariffRate, showTariffList } = tariffDataSource || {};

    return (
      <>
        {data?.isMro && (
          <span className="mr-[10px] px-[5px] inline-block h-[20px] text-nowrap rounded-[3px] border-[1px] border-solid border-[#D2E2EB] bg-[#F1F7FC] leading-[18px] text-[#1FA0E8]">
            工业品
          </span>
        )}
        {isTariff === 1 && tariffRate > 0 && (
          <Popover
            content={
              <div className="p-[10px] text-[12px]">
                <p>此商品需额外支付关税，商品总额{tariffRate}%</p>
                {(showTariffList || []).map((item, index) => {
                  return (
                    <p key={index} className="text-[#949FAB]">
                      {item.tariffName}
                      <Colon />
                      {item.rate}%
                    </p>
                  );
                })}
              </div>
            }
            placement="bottom"
            overlayClassName="lcsc-popover-wrapper"
            zIndex={2}
            align={{
              offset: [0, -5],
            }}
          >
            <span className="mr-[10px] px-[5px] inline-block h-[20px] text-nowrap rounded-[3px] border-[1px] border-solid border-[#D2E2EB] bg-[#F1F7FC] leading-[18px] text-[#1FA0E8] cursor-pointer">
              关税
            </span>
          </Popover>
        )}
        {data?.isCommercialInspection == 1 && data?.commercialInspectionCharge > 0 && (
          <span className="mr-[10px] px-[5px] inline-block h-[20px] text-nowrap rounded-[3px] border-[1px] border-solid border-[#D2E2EB] bg-[#F1F7FC] leading-[18px] text-[#1FA0E8]">
            商检
          </span>
        )}
        {data?.is3c == 1 && data?.certification3cFee > 0 && (
          <span className="mr-[10px] px-[5px] inline-block h-[20px] text-nowrap rounded-[3px] border-[1px] border-solid border-[#D2E2EB] bg-[#F1F7FC] leading-[18px] text-[#1FA0E8]">
            3C
          </span>
        )}
      </>
    );
  }, [data]);

  return (
    <div className="flex mt-[8px] text-[12px]">
      {smtDom}
      {jlcDom}
      {pcbDom}
      {otherDom}
    </div>
  );
}
